"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const FieldsTable_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/FieldsTable.vue"));
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const geom_1 = require("ol/geom");
const proj_1 = require("ol/proj");
const Utils_1 = require("@becrop/components/Map/Utils");
const Vector_1 = __importDefault(require("ol/source/Vector"));
const easing_1 = require("ol/easing");
const trans_1 = require("@common/tsutils/trans");
const VardaHelp_vue_1 = __importDefault(require("../components/modals/VardaHelp.vue"));
const VueToastify_vue_1 = __importDefault(require("@becrop/components/VueToastify/VueToastify.vue"));
let EditMetadataStep = class EditMetadataStep extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAP_ID = 'preview-map-container';
        this.MAP_CONTROLLER = new Controller_1.default();
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsSummaryStep;
        this.BEFORE_STEP = this.MAIN_CONTROLLER.workflowStep;
        this.fields_wkt = [];
        this.hasExpandPanelMap = false;
        this.hasEditShape = false;
        this.loaderSearch = false;
        this.fieldsFilters = [];
        this.textFilter = null;
        this.maximumDistanceExceeded = false;
        this.fieldsGroupModal = false;
        this.inputValueGroup = '';
        this.vueToastId = 0;
        this.MAX_DISTANCE_KM = 25;
        this.EARTH_RADIUS_KM = 6371;
    }
    showToastToEdit(msg) {
        const hasFieldsGroup = this.groupFieldsByDistance(this.STEP_CONTROLLER.data.fields).length > 1;
        if (hasFieldsGroup)
            this.triggerToast(msg);
    }
    automaticSplitting() {
        const groups = this.groupFieldsByDistance(this.STEP_CONTROLLER.data.fields);
        for (const controllerField of this.STEP_CONTROLLER.data.fields) {
            for (const group of groups) {
                for (const groupField of group.fields) {
                    if (groupField.id === controllerField.id) {
                        controllerField.farmName = `${this.inputValueGroup}_${group.groupId}`;
                    }
                }
            }
        }
        this.fieldsGroupModal = false;
    }
    fieldsGroupAction() {
        this.fieldsGroupModal = false;
    }
    setInputValue(value) {
        this.inputValueGroup = value;
    }
    updateZone() {
        if (!this.MAP_CONTROLLER.zoneSelected) {
            (0, Utils_1.removeLayerById)('vertex-layer', this.MAP_CONTROLLER.map);
        }
    }
    reUpdateZone() {
        (0, Utils_1.removeLayerById)('vertex-layer', this.MAP_CONTROLLER.map);
    }
    onSearchChange(f) {
        this.loaderSearch = true;
        this.textFilter = f;
        if (f.length > 0) {
            this.fieldsFilters = this.STEP_CONTROLLER.data.fields
                .filter((field) => field.fieldName
                .toUpperCase()
                .includes(f.toUpperCase()) ||
                field.farmName
                    .toUpperCase()
                    .includes(f.toUpperCase()))
                .map((sam) => sam);
        }
        else {
            this.textFilter = null;
            this.fieldsFilters = this.STEP_CONTROLLER.data.fields;
        }
        setTimeout(() => {
            this.loaderSearch = false;
        }, 500);
    }
    enabledFullScreen() {
        this.MAP_CONTROLLER.enabledFullScreen();
    }
    beforeStep() {
        this.STEP_CONTROLLER.resetStep();
        this.MAIN_CONTROLLER.filesSummaryStep.resetStep();
        this.MAIN_CONTROLLER.vardaStep.resetStep();
        this.MAIN_CONTROLLER.setCurrentStep(this.BEFORE_STEP);
    }
    nextStep() {
        this.NEXT_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.selectedFields);
        this.MAIN_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
        let mode = (this.MAIN_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.MAIN_CONTROLLER.logActivity({
            'name': `Farm ${mode} Step 3 Completed: Metadata Edition`,
            'status': 'ok',
        });
    }
    expandPanelMap() {
        this.hasExpandPanelMap = !this.hasExpandPanelMap;
    }
    get hasEnabledViewSummary() {
        if (this.STEP_CONTROLLER.data.selectedFields.length > 0) {
            return this.STEP_CONTROLLER.data.selectedFields.every((selectField) => {
                var _a;
                return selectField.farmName.length > 0 && selectField.fieldName.length > 0 && ((_a = selectField.crop) === null || _a === void 0 ? void 0 : _a.name.length) > 0;
            });
        }
        else {
            return false;
        }
    }
    get fieldModify() {
        return this.MAP_CONTROLLER.currentFieldModify;
    }
    get currentFieldModifyWKT() {
        return this.MAP_CONTROLLER.currentFieldModifyWKT;
    }
    async centerShapes() {
        const fields_wktt = [];
        this.STEP_CONTROLLER.data.selectedFields.forEach((field) => {
            fields_wktt.push(field.geodata);
        });
        if (fields_wktt.length > 0) {
            const polygonsWkt = fields_wktt.map(Utils_1.parseWKT);
            const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
            const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
            this.MAP_CONTROLLER.map.getView().fit(extent, { duration: 0, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
        }
    }
    updateFields() {
        this.adjustFarmNames();
        this.STEP_CONTROLLER.data.fields.forEach((field) => {
            if (`${field.id}-${field.fieldName}` === this.fieldModify.get('name')) {
                field.setGeodata(this.MAP_CONTROLLER.currentFieldModifyWKT.toString());
                field.updateSize();
            }
        });
    }
    //-----------------
    groupFieldsByDistance(fields) {
        //initial commit
        const MAX_DISTANCE_KM = 25;
        const groups = [];
        fields.forEach(field => {
            const [lon, lat] = this.parseGeodataToCoordinates(field.geodata);
            const fieldCoords = (0, proj_1.fromLonLat)([lon, lat]);
            let added = false;
            for (const group of groups) {
                // Verifica si el nuevo campo está a menos de 25 km de **todos** los campos del grupo
                const allWithinDistance = group.fields.every(groupedField => {
                    const [groupLon, groupLat] = this.parseGeodataToCoordinates(groupedField.geodata);
                    return this.approximateDistance(lat, lon, groupLat, groupLon) <= MAX_DISTANCE_KM * 1000;
                });
                if (allWithinDistance) {
                    group.fields.push(field);
                    added = true;
                    break;
                }
            }
            if (!added) {
                groups.push({ groupId: groups.length + 1, fields: [field] });
            }
        });
        return groups;
    }
    adjustFarmNames() {
        const groupFields = this.groupFieldsByDistance(this.STEP_CONTROLLER.data.fields);
        const farmNameGroups = new Map();
        let adjustmentsMade = false; // Flag para verificar si se hicieron cambios
        // Registrar en qué grupos aparece cada farmName
        for (const [groupId, fields] of Object.entries(groupFields)) {
            for (const field of fields.fields) {
                if (!field.farmName)
                    continue; // Ignorar campos sin farmName
                if (!farmNameGroups.has(field.farmName)) {
                    farmNameGroups.set(field.farmName, new Set());
                }
                farmNameGroups.get(field.farmName).add(groupId);
            }
        }
        // Ajustar nombres duplicados en diferentes grupos
        for (const [groupId, fields] of Object.entries(groupFields)) {
            for (const field of fields.fields) {
                if (!field.farmName)
                    continue; // No modificar si no tiene farmName
                const groupsWithSameName = farmNameGroups.get(field.farmName);
                if (groupsWithSameName && groupsWithSameName.size > 1) {
                    field.farmName = `${field.farmName}_${groupId}`;
                    adjustmentsMade = true; // Se realizó un ajuste
                }
            }
        }
        return adjustmentsMade; // Retorna si se hicieron cambios
    }
    //-----------------
    triggerToast(msg, theme = 'info') {
        const toast = this.$refs.toastComponent;
        this.vueToastId += 1;
        toast.showToast(this.vueToastId, msg, 20000, theme);
    }
    mounted() {
        this.MAP_CONTROLLER.create(this.MAP_ID, this.mapConfig.provider, this.mapConfig.apikey, '', '', '');
        this.MAP_CONTROLLER.addSelectInteractions();
        if (this.MAIN_CONTROLLER.isAddingFields) {
            this.MAIN_CONTROLLER.fieldsPreviewTableStep.data.fields.forEach((f) => {
                f.farmName = this.MAIN_CONTROLLER.farmToAddFields;
                f.crop = this.MAIN_CONTROLLER.crop;
                f.evaluateFieldDistance(this.MAIN_CONTROLLER.editFarmGeodata);
            });
        }
        this.drawFieldInMap();
        if (!this.MAIN_CONTROLLER.isAddingFields) {
            const hasFieldsGroup = this.groupFieldsByDistance(this.STEP_CONTROLLER.data.fields).length > 1;
            this.updateFieldNamesByGrouping();
        }
        /* if (hasFieldsGroup) {
            this.maximumDistanceExceeded = true;
            this.fieldsGroupModal = true;

            const adjustmentsMade = this.adjustFarmNames();

            if (adjustmentsMade) {
                this.triggerToast(trans('setup_activation.autobreak.alert_1'));
            }

        } else {
            this.maximumDistanceExceeded = false;
            this.fieldsGroupModal = false;
        } */
    }
    get isAddingFields() {
        return this.MAIN_CONTROLLER.isAddingFields;
    }
    get selectedFields() {
        return this.STEP_CONTROLLER.data.selectedFields;
    }
    clearMap() {
        (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
        this.fields_wkt = [];
        if (this.STEP_CONTROLLER.data.selectedFields.length > 0) {
            this.drawFieldInMap();
        }
    }
    async drawFieldInMap() {
        const layer = (0, Utils_1.findLayerById)('zone-layer', this.MAP_CONTROLLER.map);
        const featuresNames = [];
        var source = null;
        if (layer) {
            source = layer.getSource();
        }
        var features = [];
        if (source instanceof Vector_1.default) {
            features = source.getFeatures();
        }
        // Recorrer los features
        features.forEach(function (feature) {
            featuresNames.push(feature.get('name'));
        });
        this.selectedFields.forEach((field) => {
            var _a, _b;
            if (!featuresNames.includes(`${field.id}`)) {
                this.fields_wkt.push(field.geodata);
                this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                    geoData: field.geodata,
                    fillColor: field.crop ? `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50` : '#eebb5460',
                    strokeColor: field.crop ? (_b = field.crop) === null || _b === void 0 ? void 0 : _b.color : '#eebb54',
                    enableHoverInteraction: true,
                    enableSelectInteraction: true,
                    zoneName: `${field.id}-${field.fieldName}`,
                    centerZone: false,
                    avg: 0,
                    markers: [],
                    preciseResult: false,
                    modifyInteraction: true
                }), 700, [150, 150, 150, 150]);
            }
        });
        if (this.fields_wkt.length > 0) {
            const polygonsWkt = this.fields_wkt.map(Utils_1.parseWKT);
            const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
            const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
            this.MAP_CONTROLLER.map.getView().fit(extent, { duration: 700, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
        }
    }
    get farmAutoBreakGroups() {
        return this.createFieldGroupsByDistanceAndCrop(this.STEP_CONTROLLER.data.fields);
    }
    parseGeodataToCoordinates(geodata) {
        const match = geodata.match(/\(\((-?[0-9.]+) (-?[0-9.]+)/);
        if (!match)
            throw new Error('Invalid geodata format');
        return [parseFloat(match[1]), parseFloat(match[2])];
    }
    approximateDistance(lat1, lon1, lat2, lon2) {
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const meanLat = ((lat1 + lat2) / 2) * (Math.PI / 180);
        const x = dLon * Math.cos(meanLat);
        const y = dLat;
        return Math.sqrt(x * x + y * y) * this.EARTH_RADIUS_KM * 1000;
    }
    calculateDistanceKm(lat1, lon1, lat2, lon2) {
        const R = 6371; // km
        const dLat = this.deg2rad(lat2 - lat1);
        const dLon = this.deg2rad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
    deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
    formatCoordinates(lat, lon) {
        const latDirection = lat >= 0 ? 'N' : 'S';
        const lonDirection = lon >= 0 ? 'E' : 'W';
        const formattedLat = `${Math.abs(lat).toFixed(2)}${latDirection}`;
        const formattedLon = `${Math.abs(lon).toFixed(2)}${lonDirection}`;
        return `(${formattedLat}, ${formattedLon})`;
    }
    createFieldGroupsByDistanceAndCrop(fields) {
        const MAX_FIELD_DISTANCE_KM = 25;
        const GROUPS_FIELDS = [];
        let groupId = 1;
        const farmsMap = {};
        fields.forEach(field => {
            const farmName = field.farmName;
            if (!farmsMap[farmName]) {
                farmsMap[farmName] = [];
            }
            farmsMap[farmName].push(field);
        });
        Object.entries(farmsMap).forEach(([farmName, farmFields]) => {
            const cropsMap = {};
            farmFields.forEach(field => {
                const cropName = field.crop.name;
                if (!cropsMap[cropName]) {
                    cropsMap[cropName] = [];
                }
                cropsMap[cropName].push(field);
            });
            Object.entries(cropsMap).forEach(([cropName, cropFields]) => {
                const distanceGroups = [];
                cropFields.forEach(field => {
                    const [lon1, lat1] = this.parseGeodataToCoordinates(field.geodata);
                    let added = false;
                    for (const group of distanceGroups) {
                        if (group.some(existingField => {
                            const [lon2, lat2] = this.parseGeodataToCoordinates(existingField.geodata);
                            const distance = this.calculateDistanceKm(lat1, lon1, lat2, lon2);
                            return distance <= MAX_FIELD_DISTANCE_KM;
                        })) {
                            group.push(field);
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        distanceGroups.push([field]);
                    }
                });
                distanceGroups.forEach(groupFields => {
                    GROUPS_FIELDS.push({
                        id: groupId++,
                        name: `${farmName} - ${cropName}`,
                        cropName,
                        fields: groupFields,
                    });
                });
            });
        });
        GROUPS_FIELDS.forEach((group, index) => {
            console.log('-----');
            console.log(`🔷 Grupo ${index + 1}:`);
            console.log(`🏡 Name: ${group.name}`);
            console.log(`🌱 Cultivo: ${group.cropName}`);
            console.log(`📦 Total de fields: ${group.fields.length}`);
        });
        return GROUPS_FIELDS;
    }
    findExistingGroup(groups, lat, lon, cropName, maxDistanceKm) {
        return groups.find(group => group.cropName === cropName &&
            group.fields.every(groupedField => {
                const [groupLon, groupLat] = this.parseGeodataToCoordinates(groupedField.geodata);
                return this.approximateDistance(lat, lon, groupLat, groupLon) <= maxDistanceKm * 1000;
            })) || null;
    }
    createNewGroup(id, lat, lon, cropName, field) {
        return {
            id,
            name: `Farm-${cropName}${this.formatCoordinates(lat, lon)}`,
            cropName,
            fields: [field]
        };
    }
    get farmsCount() {
        const farmNames = new Set();
        this.STEP_CONTROLLER.data.selectedFields.forEach(obj => farmNames.add(obj.farmName));
        return farmNames.size;
    }
    editBulkFarmName(newName) {
        this.updateFieldNamesByGrouping(newName, false, true);
    }
    editIndividualFarmName(newName, field) {
        this.updateFieldNameForSingleField(field, newName);
    }
    editFarmNameByCrop(name) {
        this.updateFieldNamesByGrouping(name, true);
    }
    editFarmNameByCropIndividual(field) {
        this.updateSingleFieldNameByCrop(field, undefined, true);
    }
    updateSingleFieldNameByCrop(field, customBaseName, origin) {
        if (!field)
            return;
        const fields = this.STEP_CONTROLLER.data.fields;
        const groups = this.createFieldGroupsByDistanceAndCrop(fields);
        const group = groups.find(g => g.fields.includes(field));
        if (!group)
            return;
        const farmName = field.farmName || 'Farm';
        const formattedName = farmName.includes('-')
            ? farmName.split('-').slice(0, -1).join('-')
            : farmName;
        const baseName = origin ? formattedName : customBaseName || farmName;
        const isSingleGroup = groups.length === 1;
        const allSameCrop = group.fields.every(f => { var _a; return ((_a = f.crop) === null || _a === void 0 ? void 0 : _a.name) === group.cropName; });
        let newFieldName = '';
        if (isSingleGroup && allSameCrop) {
            // Solo baseName
            newFieldName = baseName;
        }
        else {
            // Coordenadas del primer field del grupo
            const [lon, lat] = this.parseGeodataToCoordinates(group.fields[0].geodata);
            //newFieldName = `${baseName}-${field.crop.name}${this.formatCoordinates(lat, lon)}`;
            newFieldName = `${baseName}-${field.crop.name}`;
        }
        field.farmName = newFieldName;
    }
    updateFieldNamesByGrouping(customBaseName, origin, bulk) {
        const groups = this.createFieldGroupsByDistanceAndCrop(this.STEP_CONTROLLER.data.fields);
        const fields = bulk ? this.STEP_CONTROLLER.data.selectedFields : this.STEP_CONTROLLER.data.fields;
        const fieldNameMap = new Map();
        const isSingleGroup = groups.length === 1;
        const group = isSingleGroup ? groups[0] : null;
        const allSameCrop = isSingleGroup && (group === null || group === void 0 ? void 0 : group.fields.every(f => { var _a; return ((_a = f.crop) === null || _a === void 0 ? void 0 : _a.name) === group.cropName; }));
        if (isSingleGroup && allSameCrop) {
            // usar baseName sin crop ni coordenadas
            const farmName = group.fields[0].farmName || 'Farm';
            const formattedName = farmName.includes('-')
                ? farmName.split('-').slice(0, -1).join('-')
                : farmName;
            const baseName = origin ? formattedName : customBaseName || farmName;
            group.fields.forEach(field => fieldNameMap.set(field, baseName));
        }
        else {
            const baseNameMap = groups.map(group => {
                const sampleField = group.fields[0];
                const farmName = sampleField.farmName || 'Farm';
                const formattedName = farmName.includes('-') ? farmName.split('-').slice(0, -1).join('-') : farmName;
                return origin ? formattedName : customBaseName || farmName;
            });
            // Ver si hay duplicados
            const nameSet = new Set(baseNameMap);
            const hasDuplicates = nameSet.size !== baseNameMap.length;
            groups.forEach(group => {
                const [lon, lat] = this.parseGeodataToCoordinates(group.fields[0].geodata);
                group.fields.forEach(field => {
                    const farmName = field.farmName || 'Farm';
                    const formattedName = farmName.includes('-')
                        ? farmName.split('-').slice(0, -1).join('-')
                        : farmName;
                    const baseName = origin ? formattedName : customBaseName || farmName;
                    //const groupName = `${baseName}-${group.cropName}${this.formatCoordinates(lat, lon)}`;
                    const groupName = hasDuplicates ? `${baseName}-${group.id}` : baseName;
                    group.fields.forEach(field => {
                        fieldNameMap.set(field, groupName);
                    });
                });
            });
        }
        fields.forEach(field => {
            if (fieldNameMap.has(field)) {
                field.farmName = fieldNameMap.get(field);
            }
        });
    }
    updateFieldNameForSingleField(field, customBaseName) {
        const groups = this.createFieldGroupsByDistanceAndCrop(this.STEP_CONTROLLER.data.fields);
        const group = groups.find(group => group.fields.includes(field));
        if (group) {
            const [lon, lat] = this.parseGeodataToCoordinates(group.fields[0].geodata);
            const baseName = customBaseName || (field.farmName || 'Farm');
            const isNameConflict = groups.some(existingGroup => existingGroup !== group && existingGroup.fields.some(existingField => existingField.farmName === baseName));
            if (!isNameConflict) {
                field.farmName = baseName;
            }
            else {
                this.triggerToast((0, trans_1.trans)('setup_activation.autobreak.alert_6'), 'error');
                /*  const groupName = `${baseName}-${group.cropName}${this.formatCoordinates(lat, lon)}`;
                 field.farmName = groupName; */
            }
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EditMetadataStep.prototype, "mapConfig", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.zoneSelected')
], EditMetadataStep.prototype, "updateZone", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('STEP_CONTROLLER.data.selectedFields')
], EditMetadataStep.prototype, "reUpdateZone", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('selectedFields')
], EditMetadataStep.prototype, "centerShapes", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentFieldModifyWKT')
], EditMetadataStep.prototype, "updateFields", null);
EditMetadataStep = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, FieldsTable: FieldsTable_vue_1.default, ArrowLeftCircle: lucide_vue_next_1.ArrowLeftCircle, ArrowRightCircle: lucide_vue_next_1.ArrowRightCircle, Plus: lucide_vue_next_1.Plus, Minus: lucide_vue_next_1.Minus, MapAttributions: bmk_ui_framework_1.MapAttributions, PenTool: lucide_vue_next_1.PenTool, Expand: lucide_vue_next_1.Expand, Minimize: lucide_vue_next_1.Minimize, Search: bmk_ui_framework_1.Search, Toasts: bmk_ui_framework_1.Toasts, VardaHelp: VardaHelp_vue_1.default, VueToastify: VueToastify_vue_1.default }
    })
], EditMetadataStep);
exports.default = EditMetadataStep;
